import React from 'react';
import { m } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { howItWorksSteps, howItWorksResult } from '../../data/content';
export function HowItWorks() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-85" data-mp="2tiddijhe7w7">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-86" data-mp="3txytw1h4tijz">
        <SectionTag data-id="element-87" data-mp="3u0urtpszc78f">Cómo funciona</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-88" data-mp="bru0hal52njw">
          Cómo usarlo (es simple)
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-89" data-mp="lif45cfo6i9o">
        <div className="space-y-3" data-id="element-90" data-mp="lkrmhqpcaun9">
          {howItWorksSteps.map((step, i) => <m.div key={step.n} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex items-start gap-4 rounded-2xl border border-navy/10 bg-cream p-5" data-id="element-91" data-mp="gk3wn8cukjum" data-mpi={i}>
              <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-navy font-heading text-sm font-bold text-white" data-id="element-92" data-mp="28d9f9e9grzhi">
                {step.n}
              </span>
              <p className="pt-0.5 text-sm leading-relaxed text-ink sm:text-base" data-id="element-93" data-mp="2ibp57dwr92pf">{step.text}</p>
            </m.div>)}
        </div>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.32
      }} className="mt-4 flex items-center gap-3 rounded-2xl border border-orange/30 bg-orange/10 p-5" data-id="element-94" data-mp="2nak03e7zyhpw">
          <CheckCircle2Icon size={22} className="flex-shrink-0 text-orange-hover" data-id="element-95" data-mp="311ospwcy69qq" />
          <p className="font-heading text-sm font-semibold text-navy sm:text-base" data-id="element-96" data-mp="362ul1t2p3uzq">{howItWorksResult}</p>
        </m.div>
      </div>
    </section>;
}